export default "__VITE_ASSET__CVHgM9CA__"